import * as React from "react"
import {
  Flex,
  Icon,
  Popover,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverTrigger,
  Portal,
  IconButton,
  Stack,
  Text,
} from "@chakra-ui/react"

import { RiShapeLine } from "react-icons/ri"

import { AlertZoneEntity, AlertEntity } from "../lib/types/alert"

import { useOrgs } from "./providers/OrgProvider"
import { AlertItem } from "./AlertItem"

interface Props {
  zone: AlertZoneEntity
  onDeselect: () => void
  alerts: AlertEntity[]
  selectedAlertUuid?: string
  refetchAlerts: () => Promise<any>
}

export const ZoneAlertMarker: React.FC<Props> = ({
  zone,
  selectedAlertUuid,
  onDeselect,
  alerts,
  refetchAlerts,
}) => {
  const { currentOrgs } = useOrgs()
  return (
    <Popover isOpen={selectedAlertUuid === zone.zone_uuid ? true : undefined} onClose={onDeselect}>
      <PopoverTrigger>
        <IconButton
          aria-label="alert marker"
          boxSize="40px"
          borderRadius="50%"
          overflow="hidden"
          _hover={{ bg: "blue.300" }}
          icon={<Icon as={RiShapeLine} boxSize="18px" color="white" />}
          bg="blue.400"
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="350px" zIndex={1000} bg="white" onClick={onDeselect}>
          <PopoverHeader>
            <Flex align="center" justify="space-between">
              <Text fontSize="1.2rem">{zone.zone_name}</Text>
            </Flex>
          </PopoverHeader>
          <PopoverBody>
            <Stack spacing={2}>
              <Stack spacing={1} maxW={360}>
                <Stack spacing={4} py={2}>
                  {alerts.map((alert) => {
                    const alertOrg = currentOrgs.find(({ url }) => url === alert.organization)!
                    return (
                      <AlertItem
                        key={alert.uuid}
                        alert={alert}
                        refetchAlerts={refetchAlerts}
                        organization={alertOrg}
                        onMuteAlert={() => null}
                      />
                    )
                  })}
                </Stack>
              </Stack>
            </Stack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  )
}
